import {Oui_TypeOuiNonReservationMarche} from './Oui_TypeOuiNonReservationMarche';
export class TypeOuiNonReservationMarche {

	public oui: Oui_TypeOuiNonReservationMarche;

	public non: string;

	constructor() { 
		 		this.oui = new Oui_TypeOuiNonReservationMarche();
		this.non = '';
 
	}
}
